<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="row">
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  錄取後可上班時間
                  <span class="en-text">Report date after hiring</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  placeholder="請選擇"
                  v-model="workedInfo.AvailableOnBoardDateOption"
                >
                  <el-option
                    label="可立即上班 (Report immediately)"
                    :value="0"
                  />
                  <el-option
                    label="通知後10天 (10 days after notified)"
                    :value="1"
                  />
                  <el-option
                    label="通知後20天 (20 days after notified)"
                    :value="2"
                  />
                  <el-option
                    label="通知後30天 (30 days after notified)"
                    :value="3"
                  />
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-12">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                招募來源管道
                <span class="en-text">Recruitment Source Channel</span>
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span class="mark">*</span>
              <span :style="{ color: fontColor }">
                是否收到日月光主動邀約?
                <span class="en-text"
                  >Have you received an unsolicited invitation from ASE?</span
                >
              </span>
            </div>

            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workedInfo.IsInvited"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workedInfo.IsInvited"
                  />
                  <span>否 (No)</span>
                </label>
              </div>

              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 招募資訊  -->

        <ValidationProvider rules="required" v-slot="{ errors }">
          <div class="col-md-12">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  您是如何得知日月光的招募資訊？(第1到第13題請擇一填寫)
                  <span class="en-text"
                    >How did you hear about ASE recruitment?(Please choose one
                    from questions 1 to 13.)</span
                  >
                </span>
              </div>
            </div>

            <span v-if="errors[0]" class="text-danger">
              {{ errors[0] }}
            </span>
            <div class="radio-title">
              <span> 1.收到日月光邀約 Received invitation from ASE： </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="2"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>電話邀約 Invite by phone call</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="3"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>公司簡訊通知 Notify by Co. text messages </span>
              </label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="radio-title">
              <span> 2.親朋好友介紹 Introduce by friends and relatives： </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="0"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>介紹人是員工 Introduce by employee </span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="1"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>介紹人非員工 Introduce by non employee</span>
              </label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="radio-title">
              <span> 3.前員工 Previous employee： </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="4"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>公司電話邀約 Invite by Co. phone call </span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="5"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>公司簡訊通知 Notify by Co. text messages</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="6"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>自行回廠 Decide on my own to return back factory</span>
              </label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="radio-title">
              <span> 4.徵才活動 Recruitment activity： </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="7"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span
                  >南桃園【中壢、平鎮、龍潭、楊梅、觀音、新屋】South Taouyuan
                  [Chungli, Pingchen, Longtan, Yangmei, Kuanyin, Sinwu]</span
                >
              </label>
              <label>
                <input
                  type="radio"
                  :value="8"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span
                  >北桃園【桃園、八德、大溪、龜山、蘆竹、大園、復興】North
                  Taoyuan [Taoyuan, Bade, Daxi, Gueishan, Luzhu, Dayuan,
                  Fuxing]</span
                >
              </label>
              <label>
                <input
                  type="radio"
                  :value="9"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>校園徵才，學校 Recruit at school, school：</span>
                <el-input
                  :disabled="workedInfo.RecruitmentSource !== 9"
                  v-model="workedInfo.RecruitmentSourceDescActivityShool"
                  style="display: inline-block; width: auto"
                  type="text"
                />
              </label>

              <label>
                <input
                  type="radio"
                  :value="10"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>專業機構，機構 Special organization, organization：</span>
                <el-input
                  :disabled="workedInfo.RecruitmentSource !== 10"
                  v-model="workedInfo.RecruitmentSourceDescActivityOrg"
                  style="display: inline-block; width: auto"
                  type="text"
                />
              </label>

              <label>
                <input
                  type="radio"
                  :value="11"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>其它 Others：</span>

                <el-input
                  :disabled="workedInfo.RecruitmentSource !== 11"
                  v-model="workedInfo.RecruitmentSourceDescActivityOther"
                  style="display: inline-block; width: auto"
                  type="text"
                />
              </label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="radio-title">
              <span>
                5.就業服務站推薦 Recommend by employment service center：
              </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="12"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>中壢就服站 Chungli employment service center</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="13"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>桃園就服站 Taoyuan employment service center</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="14"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>其它 Others</span>
                <el-input
                  :disabled="workedInfo.RecruitmentSource !== 14"
                  v-model="workedInfo.RecruitmentSourceDescCenterOther"
                  style="display: inline-block; width: auto"
                  type="text"
                />
              </label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="radio-title">
              <span> 6.傑報 Jye-Baw： </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="15"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>傑報Line@官方帳號 Jye-Baw Line@official account</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="16"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>便利商店便利通 Convenience stores front cover</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="17"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>0800網路平台 0800 network platform</span>
              </label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="radio-title">
              <span> 7.大型廣告輸出 Large advertisement output： </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="18"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>布條 Banner</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="19"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>看板 Billboard</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="20"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>LED牆 LED wall</span>
              </label>
            </div>
          </div>

          <div class="col-md-12">
            <div class="radio-title">
              <span> 8.宣傳單 Flyer： </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="21"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>中壢就服站 Chungli employment service center</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="22"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>桃園就服站 Taoyuan employment service center</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="23"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>里長辦公處 Village representative</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="24"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>其它 Others</span>
                <el-input
                  :disabled="workedInfo.RecruitmentSource !== 24"
                  v-model="workedInfo.RecruitmentSourceDescFlyerOther"
                  style="display: inline-block; width: auto"
                  type="text"
                />
              </label>
            </div>
          </div>

          <div class="col-md-12">
            <div class="radio-title">
              <span> 9.人力銀行主動求職 Apply at job ban： </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="25"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>104</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="26"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>1111</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="27"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>其他 Others</span>
                <el-input
                  :disabled="workedInfo.RecruitmentSource !== 27"
                  v-model="workedInfo.RecruitmentSourceDescJobBankOther"
                  style="display: inline-block; width: auto"
                  type="text"
                />
              </label>
            </div>
          </div>

          <div class="col-md-12">
            <div class="radio-title">
              <span> 10.報紙 Newspaper： </span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="28"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>自由時報 Liberty times</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="29"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>中國時報 China times</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="30"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>求職便利通 Benliton.com</span>
              </label>
            </div>
          </div>

          <div class="col-md-12">
            <div class="radio-title">
              <span> 11.網路平台 Internet platform</span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="31"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>日月光Line@官方帳號 ASE Line@official account</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="32"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>Facebook (FB)</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="33"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>Instagram (IG)</span>
              </label>
            </div>
          </div>

          <div class="col-md-12">
            <div class="radio-title">
              <span> 12.Hunter 推薦 Recommended by Hunter</span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="34"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>Hunter 推薦 Recommended by Hunter</span>

                <el-input
                  :disabled="workedInfo.RecruitmentSource !== 34"
                  v-model="workedInfo.RecruitmentSourceDescHunter"
                  style="display: inline-block; width: auto"
                  type="text"
                />
              </label>
            </div>
          </div>

          <div class="col-md-12">
            <div class="radio-title">
              <span> 13.其他招募來源 Other recruitment source</span>
            </div>
            <div class="radio-wrap">
              <label>
                <input
                  type="radio"
                  :value="35"
                  v-model="workedInfo.RecruitmentSource"
                />
                <span>其他招募來源 Other recruitment source</span>

                <el-input
                  :disabled="workedInfo.RecruitmentSource !== 35"
                  v-model="workedInfo.RecruitmentSourceDescOtherSource"
                  style="display: inline-block; width: auto"
                  type="text"
                />
              </label>
            </div>
          </div>
        </ValidationProvider>
        <!-- end 招募資訊  -->

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  是否曾經任職本公司？
                  <span class="en-text"
                    >Have you worked for this company before ?</span
                  >
                </span>
              </div>
              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workedInfo.HasWorkedInCompany"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workedInfo.HasWorkedInCompany"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <template v-if="workedInfo.HasWorkedInCompany">
          <div class="col-md-6">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  過去任職廠處 (例如lAssy1/HR)
                  <span class="en-text">Previous dept (ex: Assy1/HR)</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="workedInfo.WorkedDepartment"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  過去任職站點/單位 (例如DB/Recruit)
                  <span class="en-text"
                    >Previous station/unit (ex: DB/Recruit)</span
                  >
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="workedInfo.WorkedStation"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  任職期間工號
                  <span class="en-text">Previous Badge no.</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="workedInfo.WorkedBadge"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  任職期間直屬主管
                  <span class="en-text">Previous immediate supervisor</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="workedInfo.WorkedSupervisor"
                />
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  過去任職本公司到職時間
                  <span class="en-text"
                    >Previous employment report date into the company</span
                  >
                </span>
              </div>
              <div class="field-value">
                <el-date-picker
                  class="w-100"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="YYYY-MM-DD"
                  v-model="workedInfo.WorkedFrom"
                />
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  過去任職本公司離職時間
                  <span class="en-text"
                    >Previous resignation date from the company</span
                  >
                </span>
              </div>
              <div class="field-value">
                <el-date-picker
                  class="w-100"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="YYYY-MM-DD"
                  v-model="workedInfo.WorkedTo"
                />
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  離職原因說明
                  <span class="en-text">Reason of resignation</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="3"
                  maxlength="200"
                  show-word-limit
                  v-model="workedInfo.WorkedLeaveReason"
                />
              </div>
            </div>
          </div>
        </template>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  是否曾經應徵本公司？
                  <span class="en-text"
                    >Have you applied for this company before ?</span
                  >
                </span>
              </div>
              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workedInfo.HasAppliedCompany"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workedInfo.HasAppliedCompany"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div v-if="!workedInfo.HasAppliedCompany" class="col-md-6"></div>

        <template v-if="workedInfo.HasAppliedCompany">
          <div class="col-md-6">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  應徵時間
                  <span class="en-text">Applied date</span>
                </span>
              </div>
              <div class="field-value">
                <el-date-picker
                  class="w-100"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="YYYY-MM-DD"
                  v-model="workedInfo.appliedDate"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  應徵職缺
                  <span class="en-text">Applied job vacancy</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="workedInfo.AppliedJob"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="edit-btn-wrap">
        <!-- 儲存 -->
        <button
          type="button"
          class="put-btn"
          @click="handleSubmit(saveWorkedInfo)"
        >
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLWorkedInfo",

  data() {
    return {
      workedInfo: {},

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 面談背景資料
    saveWorkedInfo() {
      this.$api.idl
        .putWorkedInfo(this.source, {
          ...this.workedInfo,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "面談背景資料儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getWorkedInfo();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 面談背景資料
    getWorkedInfo() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl.getWorkedInfo(this.source, candidate).then((response) => {
        if (response.status === 200) {
          this.workedInfo = response.data;
        }
        this.updateLoading(false);
      });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    // 是否曾經任職本公司
    "workedInfo.HasWorkedInCompany": function (newVal) {
      if (newVal === false) {
        this.workedInfo.WorkedDepartment = null;
        this.workedInfo.WorkedStation = null;
        this.workedInfo.WorkedBadge = null;
        this.workedInfo.WorkedSupervisor = null;
        this.workedInfo.WorkedFrom = null;
        this.workedInfo.WorkedTo = null;
        this.workedInfo.WorkedLeaveReason = null;
      }
    },

    // 是否曾經應徵本公司
    "workedInfo.HasAppliedCompany": function (newVal) {
      if (newVal === false) {
        this.workedInfo.appliedDate = null;
        this.workedInfo.AppliedJob = null;
      }
    },

    "workedInfo.RecruitmentSource": function (newVal, oldVal) {
      // 跳過 API 首次載入帶入值的情況，避免清掉伺服器回傳的 desc
      if (oldVal === undefined) return;
      this.workedInfo.RecruitmentSourceDescActivityShool = null;
      this.workedInfo.RecruitmentSourceDescActivityOrg = null;
      this.workedInfo.RecruitmentSourceDescActivityOther = null;
      this.workedInfo.RecruitmentSourceDescCenterOther = null;
      this.workedInfo.RecruitmentSourceDescFlyerOther = null;
      this.workedInfo.RecruitmentSourceDescJobBankOther = null;
      this.workedInfo.RecruitmentSourceDescHunter = null;
      this.workedInfo.RecruitmentSourceDescOtherSource = null;
    },
  },

  created() {
    this.getWorkedInfo();
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}
.edit-btn-wrap {
  .put-btn {
    margin-top: 20px;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    color: #fff;
    background: #18c58b;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

.radio-title {
  margin-bottom: 10px;
  font-size: 0.8em;
  span {
    position: relative;
    z-index: 2;
    background-color: #d4d4d4;
    display: block;
    padding: 3px 10px;
    border-radius: 3px;
  }
  &:after {
    content: "";
    width: 100%;
    height: 1px;
    background-color: #000;
    display: block;
    opacity: 0.1;
    position: relative;
    top: -9px;
  }
}

.radio-wrap {
  font-size: 0.9em;
  label {
    margin-right: 20px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }

  input[type="radio"] {
    margin-right: 2px;
  }
}
</style>
